import { Dashboard } from "./pages/dashboard";

export default {
  component: Dashboard,
  url: '/',
  exact: true,
};
